const rewardSettle = [{
  desc: '选中保单/移动端发起结算',
  options: {
    url: '/rewardSettle/rewardSettleApply',
    method: 'post'
  }
}, {
  desc: '导入奖励结算',
  options: {
    url: '/rewardSettle/importInsuranceRewardSettle',
    method: 'post'
  }
}, {
  desc: '奖励结算审批列表',
  options: {
    url: '/rewardSettle/queryPageSettleBatch'
  }
}, {
  desc: '奖励结算审批',
  options: {
    url: '/rewardSettle/insuranceRewardSettleAudit',
    method: 'post'
  }
}, {
  desc: '获取结算单明细',
  options: {
    url: '/rewardSettle/getRewardSettleDetail',
    argsParams: true
  }
}, {
  desc: '批量选中审批单',
  options: {
    url: '/rewardSettle/getBatchRewardSettle',
    method: 'post'
  }
}, {
  desc: '奖励结算导出支付审批单',
  options: {
    url: '/rewardSettle/exportPayApplyData',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '奖励结算审批拒绝',
  options: {
    url: '/rewardSettle/rewardSettleReject',
    method: 'post'
  }
}, {
  desc: '导出未校验通过数据',
  options: {
    url: '/rewardSettle/exportRewardSettleCheckFailData',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '结算日志',
  options: {
    url: '/rewardSettle/getRewardSettleLog',
    method: 'get'
  }
}, {
  desc: '结算信息',
  options: {
    url: '/rewardSettle/exportSettleItem',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '奖励结算负责人奖励比例详情',
  options: {
    url: '/rewardSettle/getRewardSettleByInsId'
  }
}]
export default rewardSettle



// WEBPACK FOOTER //
// ./src/api/rewardSettle.js